<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入演出ID" v-model="params.activityId" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="手机" :value="1"></el-option>
                            <el-option label="姓名" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/userPermit/add')" type="primary" icon="el-icon-circle-plus" @click="add" size="small">新增工作人员</el-button>
            <el-button v-if="$utils.have('/userPermit/batchSend')" type="primary" icon="el-icon-s-promotion" @click="batchSend" size="small">批量发送短信</el-button>
            <el-button v-if="$utils.have('/userPermit/batchImport')" type="primary" icon="el-icon-upload" @click="batchImport" size="small">批量导入</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="activityIds" label="演出ID"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="telephone" label="手机"></el-table-column>
                <el-table-column prop="createTime" label="新增时间" min-width="90"></el-table-column>
                <el-table-column prop="sendTime" label="最近发送短信通知时间" min-width="90"></el-table-column>
                <el-table-column fixed="right" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/userPermit/edit')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/userPermit/delete')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                        <el-button
                            v-if="$utils.have('/userPermit/send')"
                            type="text"
                            size="small"
                            icon="el-icon-position"
                            @click="send(scope.row.id)"
                            >发放通行证</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <batch-import ref="batchImport" @onUpdate="getDataList"></batch-import>
    </div>
</template>
<script>
import BatchImport from './components/batchImport';
const defaultParams={
    pageNo: 1,
    activityId:'',
    searchValue:'',
    searchType:1,
}
    export default {
        components:{BatchImport},
        data(){
            return {
                data: null,
                dataList: null,
                params: {
                    pageNo: parseInt(this.$route.query.pageNo || 1),
                    activityId:this.$route.query.activityId || '',
                    searchValue:this.$route.query.searchValue || '',
                    searchType:parseInt(this.$route.query.searchType || 1),
                    pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
                },
                listLoading: true
            }
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //获取列表
            getDataList(){
                this.listLoading = true;
                this.$request({
                    url: '/userPermit/pageList',
                    method: 'POST',
                    data: this.params
                }).then(res => {
                    const { state, msg, result } = res.data;
                    if( state == 1 && result ){
                        this.data = result;
                        this.dataList = result.result || [];
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            },
            //选择pageSize
            handleSizeChange( e ){
                this.params.pageNo = 1
                this.params.pageSize = e
                this.getDataList()
            },
            //搜索
            search() {
                this.params.pageNo = 1;
                this.getDataList();
            },
            //重置搜索
            reset() {
                this.params = {
                    ...defaultParams,
                    pageSize: this.params.pageSize
                }
                this.getDataList();
            },
            //删除
            del(id){
                const _msg = '确定要删除吗?';
                this.$confirm(_msg, '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/userPermit/delete',
                        method: 'POST',
                        data: {id:id}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                })
            },
            //发送通信证
            send(id){
                const _msg = '确定要发送吗?';
                this.$confirm(_msg, '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/userPermit/send',
                        method: 'POST',
                        data: {userPermitId:id}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.$message.success('发送成功');
                            this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                })
            },
            //新增事件
            add(){
                this.$router.push('/user/userPermit/add');
            },
            //编辑事件
            edit(id) {
                this.$router.push({
                    path: `/user/userPermit/edit/${id}`,
                    query: {
                        redirect: this.$utils.objArgs(
                            this.$router.currentRoute.path,
                            this.params
                        ),
                    },
                });
            }, 
            //批量发送短信
            batchSend(){
                const _msg = '确定要批量发送吗?';
                this.$confirm(_msg, '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    //this.listLoading = true;
                    this.$request({
                        url: '/userPermit/batchSend',
                        method: 'POST',
                        data: {...this.params}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.$message.success('发送成功');
                            //this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        //this.listLoading = false;
                    });
                })
            },
            //导入事件
            batchImport(){
                this.$refs.batchImport.show();
            }
        }
    }
</script>